import { useState } from "react";
import Header from "./Header";
import Footer from "./Footer";
import BottomBarIcons from "./BottomBarIcons";
import Sidebar from "./Sidebar";
// import EnhancedTable from "./common/EnhancedTable";
import { useNavigate, useParams, generatePath } from "react-router-dom";
import { useEffect } from "react";
import http from "../api/server";
import { GET_CLINET_ID_API, GET_SURVEY_BOOKINGS } from "../api/apiPath";
// import { UserRoles, Statuses } from "./common/constant";
import { useSelector } from "react-redux";
import DataGridTable from "./common/DataGridTable";
import LoadingComponent from "./common/LoadingComponent";
import SidebarIcons from "./SidebarIcons";

const MyBooking = () => {
  const { clientNameParam } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [hideSidebar, setHideSidebar] = useState(true);
  // const [showLoader, setShowLoader] = useState(false);
  const { userObj } = useSelector((state) => state.user);
  // const isMobile = /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
  const [bookingSurveyData, setBookingSurveyData] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const responseClient = await http.get(
          GET_CLINET_ID_API + "/" + userObj?.userId
        );

        const responseSurveyBooking = await http.get(
          GET_SURVEY_BOOKINGS +
            userObj?.userEmail +
            "&clientId=" +
            responseClient?.data?.clientId
        );
        setBookingSurveyData(responseSurveyBooking?.data);

        if (!responseSurveyBooking.status) {
          throw new Error(
            `HTTP error! status: ${responseSurveyBooking?.status}`
          );
        }
      } catch (error) {
        throw new Error(`HTTP error! status: ${error}`);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const handleBack = () => {
    navigate(
            generatePath("/client/:clientNameParam/property-form", {
              clientNameParam,
            })
    );
  };
  return (
    <>
      <div>
        <Header hideSidebar={hideSidebar} setHideSidebar={setHideSidebar} />
      </div>
      <div className="dashboard_body_main d-flex vh-100">
                 {hideSidebar ? <Sidebar setHideSidebar={setHideSidebar} hideSidebar={hideSidebar}/> : <SidebarIcons/>}

        {/* {loading ? (
          <div className="spinloader"></div>
        ) : ( */}
          <div className="d-flex dashboard_body flex-column  w-100">
            <div className="row m-0" style={{ textAlign: "left" }}>
              <div className="col-12 col-sm-6 col-lg-4 mb-4">
                <div className="card bulid_card">
                  <div className="card-body d-flex align-items-center gap-3">
                    <i className="bi bi-calendar2-check text-default fs-2"></i>
                    <div>
                      <small className="d-block">Total</small>
                      <strong className="fs-5">
                        {bookingSurveyData?.length}
                      </strong>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-12 col-sm-6 col-lg-4 mb-4">
                <div className="card bulid_card">
                  <div className="card-body d-flex align-items-center gap-3">
                    <i className="bi bi-check-circle text-success fs-2"></i>
                    <div>
                      <small className="d-block">Completed</small>
                      <strong className="fs-5">
                        {
                          bookingSurveyData?.filter(
                            (item) => item.status === "Completed"
                          ).length
                        }
                      </strong>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-12 col-sm-6 col-lg-4 mb-4">
                <div className="card bulid_card">
                  <div className="card-body d-flex align-items-center gap-3">
                    <i className="bi bi-clock text-warning fs-2"></i>
                    <div>
                      <small className="d-block">Scheduled</small>
                      <strong className="fs-5">
                        {
                          bookingSurveyData?.filter(
                            (item) =>
                              item.status === "Not Started" ||
                              item.status === "In Progress"
                          ).length
                        }
                      </strong>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <form className="row m-0">
              <div className="col-12 col-sm-12 col-lg-12 mb-3 ">
                <div className="card">
                  <div className="card-body">
                    <h5 className="justifyStart">Booking Details</h5>

                    <div className="table-responsive">
                      {/* {complianceData?.doorComplianceDetails?.length > 0 && (
                      <EnhancedTable
                        tableData={complianceData.doorComplianceDetails}
                      />
                    )} */}
                      {bookingSurveyData?.length > 0 && (
                        <DataGridTable
                          IsBookingSurveyGrid
                          tableData={bookingSurveyData.sort(
                            (a, b) =>
                              new Date(b.bookedDate) - new Date(a.bookedDate)
                          )}
                        />
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <div className="card-body action_btns d-flex justify-content-end gap-3 pb-3 px-3 flex-wrap flex-sm-nowrap">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => {
                    handleBack();
                  }}
                >
                  Back
                </button>
              </div>
            </form>
            <Footer />
<div className="bottom-bar-spacing"></div>
<BottomBarIcons />
          </div>
          <LoadingComponent loading={loading}/>
        {/* )} */}
      </div>
    </>
  );
};
export default MyBooking;
